import * as S from './styles';
import { useTheme } from 'styled-components';
import Text from '@/components/atoms/Text';
import { IconeEstrela } from '@/components/atoms/Icones/IconeEstrela';
import { IconeChippu } from '@/components/atoms/Icones/IconeChippu';
import { CSSProperties } from 'react';

interface NotasEmLinhaProps {
  $notaEstrela?: number;
  $notaChippu?: number;
  $colorido: boolean;
  style?: CSSProperties;
}

export default function NotasEmLinha(props: NotasEmLinhaProps) {
  const { $notaEstrela, $notaChippu, $colorido, style } = props;

  const theme = useTheme();

  return (
    <S.Row style={style}>
      {$notaChippu != null ? (
        <S.Row style={{ gap: theme.spacing[2] }}>
          <IconeChippu
            size={14}
            color={$colorido ? theme.colors.accent.accent[9] : 'white'}
          />
          <Text
            $size={2}
            $color={''}
            $weight="bold"
            $align="center"
            $highContrast={true}
            $text={`${$notaChippu}/5`}
          />
        </S.Row>
      ) : null}
      {$notaEstrela != null ? (
        <S.Row style={{ gap: theme.spacing[2] }}>
          <IconeEstrela
            size={18}
            color={$colorido ? '#FFAC33' : 'white'}
            $fillColor={$colorido ? '#FFAC33' : 'white'}
          />
          <Text
            $size={2}
            $color={''}
            $weight="bold"
            $align="center"
            $highContrast={true}
            $text={`${$notaEstrela}/5`}
          />
        </S.Row>
      ) : null}
    </S.Row>
  );
}
